import { Injectable } from '@angular/core';
import { CommonRestService } from './CommonRest.service';
import { environment } from '../../environments/environments';


@Injectable({ providedIn: 'root' })
export class BusinessCommonService {
  constructor(private commonService: CommonRestService) { }
  getResourcesByName(searchText) {
    return this.commonService.commonGet("/search/getResourceByName?searchText=" + searchText);
  }
  saveCollectionData(subListId, customerInfoExt) {
    return this.commonService.commonPost(environment.baseUrl+"/api/business/saveCollection/" + subListId, customerInfoExt);
  }

  updateCollectionData(subListId, customerInfoExt) {
    return this.commonService.commonPost(environment.baseUrl+"/api/business/update-collection/" + subListId, customerInfoExt);
  }



  getSubfileMetaData(listId: string) {
    return this.commonService.commonGet(environment.baseUrl+"/api/business/getMetaData?subListId=" + listId);
  }

  getfieldsMetaData(listId: number) {
    return this.commonService.commonGet(environment.baseUrl+"/api/get-fields-meta?subListId=" + listId);
  }

  getSubfileMetaFieldsMap(listId: string, file: any) {
    return this.commonService.commonPost(environment.baseUrl+"/api/get-fields/" + listId, file);

  }

  saveSubfileMetaFieldsMap(listId: string, datas: any) {
    return this.commonService.commonPost(environment.baseUrl+"/api/saveSubFileMetaFieldMap/" + listId, datas);

  }
  getSubfileMetaDataById(listId: string, id: number, isMaker: any) {
    return this.commonService.commonGet(environment.baseUrl+"/api/get-subdata-by-id?subListId=" + listId + "&id=" + id + "&isMaker=" + isMaker);
  }

  deleteData(listId: any, data: any) {
    const url = environment.baseUrl+"/api/business/delete-collection/" + listId;
    return this.commonService.commonPostWithReqBody(url, data);

  }

  getSubListPositionMap(subListIdnty, pageType): any {
    const url = environment.baseUrl+'/api/business/getSubListpositionMap/';
    return this.commonService.commonGetWithPathVariables(url, subListIdnty, pageType);
  }

  getUploadListPositionsMap(subListIdnty, uploadId): any {
    const url = environment.baseUrl+'/api/business/getUploadListpositionsMap/';
    return this.commonService.commonGetWithPathVariables(url, subListIdnty, uploadId);
  }




  getUserListByIdList(idList: number[]) {
    const url = environment.baseUrl + "/api/user/get-user-profile-list";
    return this.commonService.commonPostWithReqBody(url, idList);
  }


}
